import { Descriptions as AntdDescriptions } from "antd";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import AppContext from "../../../context/app/context";
import CommonQuestionsContext from "../../../context/common-question/context";
import Descriptions from "../../general/antd/descriptions";
import Spin from "../../general/antd/spin";
import PageDetails from "../../general/details";
import CommonQuestionsContextProvider from "../../../context/common-question/provider";
import { getFor, getForColor } from "../../../models/common-question/enum";
import Tag from "../../general/antd/tag";

interface Props { }

const CommonQuestion: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const { details, actions, loading } = useContext(CommonQuestionsContext);
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    const getDetails = async () => {
      id && (await actions.getDetails(Number(id)));
    };
    getDetails();
  }, [direction]);
  return (
    <>
      <PageDetails
        title={t("details")}
        subtitle={t("common_questions")}
        buttonName={`${t("update_commen_question")}`}
        onClick={() => navigate(`/common-questions/update/${id}`)}
      >
        {loading.includes("details") ? (
          <Spin />
        ) : (
          <Descriptions size="small" column={1} bordered>
            <AntdDescriptions.Item label={t("id")}>
              {details?.id}
            </AntdDescriptions.Item>
            <AntdDescriptions.Item label={t("question")}>
              {details?.question ?? "-"}
            </AntdDescriptions.Item>
            <AntdDescriptions.Item label={t("answer")}>
              {details?.answer ?? "-"}
            </AntdDescriptions.Item>
            {/*<AntdDescriptions.Item label={t("for")}>*/}
            {/*  <Tag*/}
            {/*    color={getForColor(details?.for)}*/}
            {/*    title={getFor(details?.for)}*/}
            {/*  />*/}
            {/*</AntdDescriptions.Item>*/}
          </Descriptions>
        )}
      </PageDetails>
    </>
  );
};

const CommonQuestionsDetailsPage = () => {
  return (
    <CommonQuestionsContextProvider>
      <CommonQuestion />
    </CommonQuestionsContextProvider >
  );
};
export default CommonQuestionsDetailsPage;
